$(document).on('click', '.accordion__trigger', function (event) {
    let accordionItem = $(this).closest('.accordion__item');
    if (accordionItem.hasClass('open') == false) {
        accordionItem.addClass('open');
        $(this).attr('aria-expanded', 'true');
        accordionItem.find('.accordion__content').slideToggle(450);
    } else {
        accordionItem.removeClass('open');
        $(this).attr('aria-expanded', 'false');
        accordionItem.find('.accordion__content').slideToggle(450);
    }
});